<template>

  <div class="mdl-layout mdl-js-layout mdl-layout--fixed-header">
    <main class="mdl-layout__content">
      <div class="page-content">
        <div class="logo">
          <img v-bind:src="logo">
        </div>
        <div class="mdl-card mdl-shadow--6dp" v-if="spinner">
            <div id="spinner" class="collapse">
                <div class="loader"></div>
            </div>
        </div>
        <div id="recaptcha-container"></div>
        <div class="mdl-card mdl-shadow--6dp" v-if="isStep(0)">
          <div class="mdl-card__supporting-text">
            <div v-if="errorMessage">
              {{ errorMessage }}
            </div>
            <div class="mdl-textfield mdl-js-textfield">
              <input class="mdl-textfield__input" type="tel" id="phonenumber" v-model="phoneNumber">
            </div>
          </div>
          <div class="mdl-card__actions">
            <button class="mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect" v-on:click="sendSMS">Entrar</button>
          </div>        
        </div>
        <div class="mdl-card mdl-shadow--6dp" v-if="isStep(1)">
          <div class="mdl-card__supporting-text">
            <form action="#">
              <div v-if="errorMessage">
                {{ errorMessage }}
              </div>
              <div class="mdl-textfield mdl-js-textfield">
                <input class="mdl-textfield__input" type="tel" id="sms_code" placeholder="" v-model="code">
              </div>
            </form>
          </div>
          <div class="mdl-card__actions">
            <button class="mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect" v-on:click="validate">Confirmar</button>
            <button class="mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect" v-on:click="cancel">Cancelar</button>
          </div>        
        </div>
        <div class="mdl-card mdl-shadow--6dp" v-if="isStep(2)">
          <div class="mdl-card__supporting-text">
            <form action="#">
              <div class="mdl-textfield mdl-js-textfield">
                <input class="mdl-textfield__input" type="password" placeholder="Password"/>
              </div>
              <div class="mdl-textfield mdl-js-textfield">
                <input class="mdl-textfield__input" type="password" placeholder="Password confirmation"/>
              </div>
            </form>
          </div>
          <div class="mdl-card__actions">
            <button class="mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect" v-on:click="save">Salvar</button>
            <button class="mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect" v-on:click="cancel">Cancelar</button>
          </div>        
        </div>
      </div>
    </main>
  </div>



</template>

<script>

  import firebase from 'firebase/app'
  import 'firebase/auth'
  import db from './firebaseInit'

  export default {
    data: function() {
      return {
        logo: 'https://ignisfit.bitbucket.io/img/logo-' + process.env.FSM_ENV + '.png',
        phoneNumber: process.env.FSM_AREA_CODE,
        password: '',
        passwordConfirmation: '',
        step: 0,
        confirmationResult: null,
        code: '',
        errorMessage: 'Informe o número de telefone celular',
        spinner: false
      }
    }, 
    mounted: function() {
      window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container', {'size': 'invisible'})
    },
    methods: {
      isStep: function(step) {
        return  this.step == step && this.spinner == false
      },
      sendSMS: function() {
        var data = this;
        this.spinner = true
        //this.phoneNumber = this.phoneNumber.replace(/ /g, '')
        window.signingIn = true
        var formattedPhoneNumber = this.formatPhoneNumber(data.phoneNumber)
        var currentUser = formattedPhoneNumber
        let operatorRef = db.doc('instances/' + process.env.FSM_ENV + '/people/' + currentUser)
        operatorRef.get().then(function(doc) {
          if (typeof doc.data() != 'undefined') {
            firebase.auth().signInWithPhoneNumber(formattedPhoneNumber, window.recaptchaVerifier)
              .then(function(confirmationResult) {
                window.recaptchaVerifier.clear()
                data.step = 1
                data.confirmationResult = confirmationResult
                window.signingIn = false
                data.spinner = false
                data.errorMessage = "Informe abaixo o código que recebeu por SMS"
              });
          } else {
            data.spinner = false
            data.errorMessage = "Esse número não está habilitado para esse ambiente (" + process.env.FSM_ENV + ")"
          }
        })
      },
      validate: function() {
        var data = this
        data.spinner = true

        this.confirmationResult.confirm(this.code).then(function (result) {
          console.log(result)
          var currentUser = data.formatPhoneNumber(data.phoneNumber)
          let operatorRef = db.doc('instances/' + process.env.FSM_ENV + '/people/' + currentUser)
          operatorRef.get().then(function(doc) {
            console.log(doc)
            localStorage.setItem('currentName', doc.data().name)
            localStorage.setItem('currentUser', data.formatPhoneNumber(data.phoneNumber))
            data.spinner = false
            data.login()
          })
        }).catch(function (error) {
          data.spinner = false
          data.errorMessage = error.message
        })
      },
      save: function() {
      },
      login: function() {
        //document.getElementById('header').classList.remove('hidden');
        this.spinner = false
        this.$router.push("/")
      },
      cancel: function() {
        this.errorMessage = 'Informe o número de telefone celular'
        this.step = 0
      },
      formatPhoneNumber: function(number) {
        var fullPhoneNumber = process.env.FSM_COUNTRY_CODE + number
        return fullPhoneNumber.replace(/ |\(|\)/g, '')
      }
    }

  }

</script>

<style scoped>
.logo {
  text-align: center;
  margin: 20px;
}
.mdl-card {
  margin: auto;  
}
</style>


// WEBPACK FOOTER //
// src/components/LoginView.vue